import { Flex, layout, Span, styled, Table } from '@fareye/ui'
import React from 'react'

export const ReportType = styled(Span)`
  ${(props: any) => `
    color: ${props.variant.includes('primary') ? '' : props.theme.colors.gray7};
    border-right: ${
      props.variant.includes('primary') ? '2px solid rgba(24,144,255)' : 'unset'
    };
    padding: 10px 15px;
    cursor: pointer;
    border-radius:0px;
    `}
`
export const ColFullHeight = styled((props: any) => (
  <Flex
    p={2}
    justifyContentSpaceEvenly
    alignItemsFlexStart
    column
    {...props}
    style={{ height: '100%', overflow: 'hidden' }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`

export const StyledTable = styled(Table)`
  .striped {
    tr:nth-child(even) {
      background: #e6eff4;
    }
  }
`
